import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from 'src/redux_store';
import { IShareVideo, IVideoDownload, IVideoHls, IVideoHlsBody } from 'src/types/video';
import { videoApi } from 'src/clients/http';
import { IRequestError } from 'src/types/error';
import { toastMessage } from '../common/toast/toast_action';

export const getVideoHls = createAsyncThunk<
  IVideoHls[],
  IVideoHlsBody,
  { state: RootState; rejectValue: IRequestError }
>('video/getVideoHls', async (_payload, { rejectWithValue }) => {
  try {
    const { data } = await videoApi.getVideoHls(_payload);
    return data;
  } catch (error: any) {
    toastMessage.error(error?.message || 'Lấy danh sách video lỗi');
    return rejectWithValue(error?.response?.data);
  }
});

export const shareVideo = createAsyncThunk<
  string,
  IShareVideo,
  { state: RootState; rejectValue: IRequestError }
>('video/shareVideo', async (payload, { rejectWithValue }) => {
  try {
    const { data } = await videoApi.shareVideo(payload);
    return data;
  } catch (error: any) {
    toastMessage.error(error?.messages);

    return rejectWithValue(error?.response?.data);
  }
});

export const downloadVideo = createAsyncThunk<
  string,
  IVideoDownload,
  { state: RootState; rejectValue: IRequestError }
>('video/downloadVideo', async (payload, { rejectWithValue }) => {
  try {
    const { data } = await videoApi.checkExportVideo(payload);
    if (data === 'OK') {
      videoApi.downloadVideo(payload);
    }

    return 'OK';
  } catch (error: any) {
    return rejectWithValue(error?.response?.data);
  }
});
